import styled from "styled-components";
import AirbnbMsool from "../../../../../assets/svg/AirbnbMsool.svg?react";
import UnBlockingSuccess from "../../../../../assets/svg/UnBlockingSuccess.svg?react";

interface ResponsiveProps {
  $isPhone?: boolean;
  $BgColor?: string;
  $TextColor?: string;
  $width?: string;
}

export const ModalBox = styled.div<ResponsiveProps>`
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  width: ${({ $isPhone }) => ($isPhone ? "90%" : "782px")};
  max-width: 100%;
  text-align: center;
  direction: rtl;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #e2e8f0;
`;

export const ActionContainer = styled.div<ResponsiveProps>`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  justify-content: ${({ $isPhone }) => ($isPhone ? "center" : "flex-end")};
  height: ${({ $isPhone }) => ($isPhone ? "80px" : "97px")};
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  background: white;
  padding-inline: 32px;
`;

export const StyledButton = styled.button<ResponsiveProps>`
  width: ${({ $width }) => $width || "auto"};
  height: 49px;
  border-radius: 69px;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  color: ${({ $TextColor }) => $TextColor};
  background-color: ${({ $BgColor }) => $BgColor};
  border: 1px solid #5b3fff;
  cursor: pointer;

  &:hover {
    background-color: ${({ $BgColor }) => $BgColor};
    color: ${({ $TextColor }) => $TextColor};
  }
`;

export const CloseButtonContainer = styled.div<ResponsiveProps>`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 64px;
  cursor: pointer;
  padding: ${({ $isPhone }) => ($isPhone ? "16px" : "32px")};
`;

export const ContentWrapper = styled.div<ResponsiveProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 782px;
  height: ${({ $isPhone }) => ($isPhone ? "auto" : "451px")};
  padding-inline: ${({ $isPhone }) => ($isPhone ? "16px" : "32px")};
  padding-bottom: ${({ $isPhone }) => ($isPhone ? "24px" : "0")};
  margin-block: ${({ $isPhone }) => ($isPhone ? "30px" : "")};
`;

export const StyledAirbnbIcon = styled(AirbnbMsool)<ResponsiveProps>`
  width: ${({ $isPhone }) => ($isPhone ? "120px" : "160px")};
  height: ${({ $isPhone }) => ($isPhone ? "56px" : "74px")};
`;

export const SuccessBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #16ae26;
  width: 492px;
  height: 124px;
  border-radius: 12px;
  background: #16ae260a;

  @media (max-width: 600px) {
    width: 90%;
    height: auto;
    padding: 16px;
  }
`;

export const SuccessTitle = styled.span`
  font-weight: 700;
  font-size: 20px;

  @media (max-width: 600px) {
    font-size: 18px;
    text-align: center;
  }
`;

export const SuccessDescription = styled.span`
  font-weight: 400;
  font-size: 14px;
  margin-top: 4px;

  @media (max-width: 600px) {
    font-size: 13px;
    text-align: center;
  }
`;

export const StyledSuccessIcon = styled(UnBlockingSuccess)`
  width: 38px;
  height: 38px;
  margin-bottom: 8px;
`;
